import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ReportArchiveService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data || [],
                pagination: response.pagination || {},
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch report archives');
        }
    }

    async createWithGrant(data, grantToken) {
        try {
            const response = await this.api.createWithGrant(data, grantToken);
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create report archive');
        }
    }

    async getViewerAccess(id) {
        try {
            const response = await this.api.getViewerAccess(id);
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create archived report access');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create report archive');
        }
    }

    async delete(id) {
        try {
            const response = await withRetry(() => this.api.delete(id), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete report archive');
        }
    }

    _handleError(error, fallbackMessage) {
        if (error instanceof ApiError) return error;
        return new ApiError(fallbackMessage, error?.response?.status || 500, error?.response?.data);
    }
}
